import type { ReactNode } from 'react';
import { MagnifyingGlass } from '../../../design-system/icons';
import { Input } from '../../../components/ui/input';

export type CreatorsSortColumn = 'followers' | 'avg_views' | 'engagement_rate';

/**
 * Figma: search + "Sort by" + Filters controls beside the status pills.
 *
 * Search is now controlled (query/onQueryChange). Sort and Filters are
 * commented out until BE params are wired.
 */
export function CreatorsControls({
  query = '',
  onQueryChange,
  columnsMenu,
}: {
  sortColumn?: CreatorsSortColumn | null;
  onSort?: (column: CreatorsSortColumn) => void;
  query?: string;
  onQueryChange?: (q: string) => void;
  /** Optional Columns visibility dropdown, rendered beside the search box. */
  columnsMenu?: ReactNode;
}) {
  return (
    <>
      {/* Search — controlled; filters the visible roster rows client-side */}
      <div className="relative w-80">
        <MagnifyingGlass size={16} className="absolute top-1/2 left-3 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search creators…"
          className="h-10 rounded-lg border-border bg-card pl-9"
          value={query}
          onChange={onQueryChange ? (e) => onQueryChange(e.target.value) : undefined}
        />
      </div>

      {columnsMenu}

      {/* Sort by — commented out until BE sort params are wired.
      <Popover>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="flex h-10 items-center gap-2 rounded-full border border-border bg-card px-3.5 text-body-sm-medium text-foreground transition-colors hover:bg-muted"
          >
            Sort by <CaretDown size={14} className="text-foreground" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-44 p-1">
          {SORT_OPTIONS.map((o) => (
            <button
              key={o.column}
              type="button"
              onClick={() => onSort?.(o.column)}
              className="flex w-full items-center justify-between rounded-md px-2.5 py-2 text-body-sm-regular text-foreground transition-colors hover:bg-muted"
            >
              {o.label}
              {sortColumn === o.column && <Check size={15} weight="bold" className="text-foreground" />}
            </button>
          ))}
        </PopoverContent>
      </Popover>
      */}

      {/* Filters — commented out until BE filter params are wired.
      <button
        type="button"
        title="Coming soon"
        className="flex h-10 items-center gap-2 rounded-full border border-border bg-card px-3.5 text-body-sm-medium text-foreground transition-colors hover:bg-muted"
      >
        <SlidersHorizontal size={15} className="text-foreground" /> Filters
      </button>
      */}
    </>
  );
}
